let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9vwdH")).then(() => parcelRequire('dy3yk'));